import { BlockOrderCompleteEntityHydrated } from "@jackfruit/common"
import { navigate } from "gatsby"
import React, { lazy, Suspense, useEffect } from "react"
import { useApplicationState } from "~/hooks/useApplicationState"
import { useOrder } from "~/hooks/useOrder"
import OrderCompleteSkeleton from "../order-complete/loading/OrderCompleteSkeleton"

const OrderCompleteBlock = lazy(() => import("./OrderCompleteBlock"))

interface Props {
  config: BlockOrderCompleteEntityHydrated
}

const OrderCompleteBlockWrapper: React.FC<Props> = ({ config }) => {
  const { lastOrderId: currentOrderId } = useApplicationState()
  const { order: placedOrder } = useOrder(currentOrderId)

  useEffect(() => {
    if (!placedOrder) {
      navigate("/")
    }
  }, [placedOrder])

  if (!placedOrder) {
    return null
  }

  return (
    <Suspense fallback={<OrderCompleteSkeleton />}>
      <OrderCompleteBlock config={config} />
    </Suspense>
  )
}

export default OrderCompleteBlockWrapper
